import {
  cellRenderParseData,
  cellRenderStorageTimeCount
} from '../../../utils/functions';

const columnDataGridConsignment = [
  {
    dataField: 'storageTimeCount',
    caption: 'Срок хранения',
    dataType: 'number'
  },
  {
    dataField: 'remainingTimeCount',
    caption: 'Осталось времени',
    cellRender: cellRenderStorageTimeCount,
    cssClass: 'td-button-cell-render',
    dataType: 'number'
  },
  {
    dataField: 'internalPieceId',
    caption: 'Внутренний номер УЕ',
    dataType: 'string'
  },
  {
    dataField: 'klPok',
    caption: 'Класс цинкового покрытия',
    dataType: 'string'
  },
  {
    dataField: 'cvet',
    caption: 'Цвет покрытия',
    dataType: 'string'
  },
  {
    dataField: 'dateOm',
    caption: 'Дата отгрузки Северсталь',
    cellRender: cellRenderParseData,
    dataType: 'date'
  }
];

export default columnDataGridConsignment;
